import { createAction, props } from '@ngrx/store';
import { CareerProgressionModel } from '@shared/data-access/models';

export const setList = createAction(
  '[Career Progression] SET LIST',
  props<{ items: CareerProgressionModel[] }>()
);
